/* Noorns redesign: the shared topic pills (snippets/noorns-topic-pills.liquid), used by the blog
   index (assets/noorns-blog.js) and the videos page (assets/noorns-videos-filter.js).
   window.noornsPills(row, onPick): keeps aria-pressed on the pills, keeps the choice in the
   address as ?topic=<key> (removed for All), calls onPick(key) on every pick, opens the topic
   named in the address on load, and on a phone scrolls the picked pill into view.
   Returns { pick: function (key) } so a page can reset to 'all'. An unknown key means All. */
(function () {
  window.noornsPills = function (row, onPick) {
    var pills = Array.prototype.slice.call(row.querySelectorAll('.ntp-p'));
    function show() {
      var on = row.querySelector('[aria-pressed="true"]');
      if (on && row.scrollWidth > row.clientWidth) {
        row.scrollLeft += on.getBoundingClientRect().left - row.getBoundingClientRect().left - 16;
      }
    }
    function pick(key, push) {
      if (!key || !row.querySelector('.ntp-p[data-topic="' + key + '"]')) key = 'all';
      pills.forEach(function (p) { p.setAttribute('aria-pressed', String(p.getAttribute('data-topic') === key)); });
      onPick(key);
      if (push !== false) {
        var u = new URL(location.href);
        if (key === 'all') u.searchParams.delete('topic'); else u.searchParams.set('topic', key);
        history.replaceState(null, '', u.pathname + u.search + u.hash);
      }
    }
    pills.forEach(function (p) {
      p.addEventListener('click', function () { pick(p.getAttribute('data-topic')); });
    });
    var q = new URLSearchParams(location.search).get('topic');
    if (q && q !== 'all' && row.querySelector('.ntp-p[data-topic="' + q + '"]')) { pick(q, false); show(); }
    row.classList.add('ntp-on');
    return { pick: pick };
  };
})();
